import React from 'react';
import { useTranslation } from 'react-i18next';

function DiscoverDrawerMapBackdrop({ onClose }) {
  const { t } = useTranslation('discover');

  return (
    <button
      type="button"
      className="discover-widgets-drawer-backdrop"
      onClick={onClose}
      aria-label={t('discover.drawer.closeBackdrop')}
    >
      <span className="discover-widgets-drawer-backdrop__hint" aria-hidden="true">
        <svg
          className="discover-widgets-drawer-backdrop__art"
          viewBox="0 0 200 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="ddb-grad-orange" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#fd7651" />
              <stop offset="55%" stopColor="#feb139" />
              <stop offset="100%" stopColor="#ea6820" />
            </linearGradient>
            <linearGradient id="ddb-grad-soft" x1="0%" y1="100%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(253, 118, 81, 0.15)" />
              <stop offset="100%" stopColor="rgba(254, 177, 57, 0.08)" />
            </linearGradient>
          </defs>
          <rect x="8" y="18" width="92" height="84" rx="10" fill="url(#ddb-grad-soft)" stroke="rgba(253, 118, 81, 0.35)" strokeWidth="1.2" />
          <circle cx="42" cy="52" r="10" fill="url(#ddb-grad-orange)" opacity="0.9" />
          <path
            d="M42 42 L42 68 M32 56 L52 56"
            stroke="#fff"
            strokeWidth="2.2"
            strokeLinecap="round"
            opacity="0.95"
          />
          <rect x="118" y="22" width="72" height="18" rx="4" fill="rgba(253, 118, 81, 0.22)" stroke="rgba(234, 104, 32, 0.45)" strokeWidth="1" />
          <rect x="118" y="48" width="72" height="18" rx="4" fill="rgba(254, 177, 57, 0.18)" stroke="rgba(234, 104, 32, 0.4)" strokeWidth="1" />
          <rect x="118" y="74" width="52" height="18" rx="4" fill="rgba(253, 118, 81, 0.14)" stroke="rgba(234, 104, 32, 0.35)" strokeWidth="1" />
          <path
            className="discover-widgets-drawer-backdrop__arrow"
            d="M98 60 H112 M106 54 L114 60 L106 66"
            stroke="url(#ddb-grad-orange)"
            strokeWidth="3.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152 96 L168 96 M160 90 L174 96 L160 102"
            stroke="url(#ddb-grad-orange)"
            strokeWidth="2.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.85"
          />
        </svg>
        <span className="discover-widgets-drawer-backdrop__title">{t('discover.drawer.backdropHintTitle')}</span>
        <span className="discover-widgets-drawer-backdrop__sub">{t('discover.drawer.backdropHintSub')}</span>
        <span className="discover-widgets-drawer-backdrop__tap">{t('discover.drawer.backdropTap')}</span>
      </span>
    </button>
  );
}

export default DiscoverDrawerMapBackdrop;
